import {CSSProperties} from 'react';
import {Button} from '@mui/material';

type PropsType = {
    name: string
    onClick?: () => void
    color?: 'primary' | 'error'
    type?: 'button' | 'submit'
    style?: CSSProperties
}

export const CustomButton = (props: PropsType) => {
    const {name, onClick, color = 'primary', type = 'button', style} = props

    return (
        <Button variant={'contained'}
                color={color}
                onClick={onClick}
                type={type}
                style={style}>
            {name}
        </Button>
    )
}
